export default __webpack_public_path__ + "static/media/notify-field.b6bc4cd7.png";